export function getInstantPhoneNumberSeparatorTranslationUtil({
  phone,
  country,
  clientAppId,
  context,
  interpolateParams,
  getTranslation,
}: {
  phone: string | { number: string };
  country: string;
  clientAppId: string;
  context: string;
  interpolateParams?: any;
  getTranslation: (key: string, params?: any) => any;
}): any {
  const key = `${country}.${clientAppId}.${context}`;

  return getTranslation(key, {
    ...(typeof phone === 'object' ? phone : { number: phone }),
    ...interpolateParams,
  });
}
